<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content *ngIf="data.mode === 'delete'">
  <p>Remove <strong>{{ data.drop.title }}</strong> from the drops list?</p>
  <p>This deletes the row from drops only. Member cop records stay as they are.</p>
</mat-dialog-content>

<mat-dialog-content *ngIf="data.mode === 'add'">
  <p>Add <strong>{{ data.suggestion.title }}</strong> to the drops list?</p>
  <p>
    The listed value will be the average Impact price across in-stock sizes, after dropping the highest and lowest size.
    <span *ngIf="data.suggestion.currentValue != null">of {{ data.suggestion.currentValue | currency:'USD':'symbol':'1.0-0' }}</span>.
  </p>
</mat-dialog-content>

<mat-dialog-content *ngIf="data.mode === 'selections'" class="selections">
  <div class="selections-loading" *ngIf="loading"><mat-spinner diameter="32"></mat-spinner></div>
  <p class="dialog-error" *ngIf="error">{{ error }}</p>
  <p *ngIf="!loading && !error && selections.length === 0">No members have selected this drop.</p>
  <table *ngIf="!loading && selections.length">
    <thead>
      <tr>
        <th>userID</th>
        <th>firstName</th>
        <th>lastName</th>
        <th>email</th>
        <th>membership</th>
        <th>drop_title</th>
        <th>drop_styleID</th>
        <th>dropCreateAt</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let member of selections">
        <td>{{ member.userID || '—' }}</td>
        <td>{{ member.firstName || '—' }}</td>
        <td>{{ member.lastName || '—' }}</td>
        <td>{{ member.email || '—' }}</td>
        <td>{{ member.membership || '—' }}</td>
        <td>{{ member.drop_title || '—' }}</td>
        <td>{{ member.drop_styleID || '—' }}</td>
        <td>{{ member.dropCreateAt ? (member.dropCreateAt | date:'yyyy-MM-dd HH:mm') : '—' }}</td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>

<mat-dialog-content *ngIf="data.mode === 'insight'">
  <p><strong>{{ data.drop.insight.membersCopped }}</strong> members copped</p>
  <p *ngIf="data.drop.insight.avgPricePaid != null">
    Average price paid {{ data.drop.insight.avgPricePaid | currency:'USD':'symbol':'1.0-0' }}
  </p>
  <p *ngIf="data.drop.insight.avgPricePaid == null">No paid prices recorded yet.</p>

  <div *ngIf="data.drop.insight.heatPublished; else unpublished">
    <p>Prestige {{ data.drop.insight.prestigeScore }} · {{ classLabel(data.drop.insight.prestigeClass) }}</p>
    <p *ngIf="data.drop.insight.prestigeRank">Rank {{ data.drop.insight.prestigeRank }}</p>
    <p>Heat {{ data.drop.insight.heatScore }}</p>
    <p>Early rate {{ data.drop.insight.earlyRateScore }}</p>
    <p>Scarcity {{ data.drop.insight.scarcityScore }}</p>
    <p>Premium rate {{ data.drop.insight.premiumRateScore }}</p>
  </div>
  <ng-template #unpublished>
    <p>Prestige and Heat are unpublished until this shoe has 25 collectors.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button *ngIf="data.mode === 'insight' || data.mode === 'selections'" (click)="close(false)">Close</button>
  <ng-container *ngIf="data.mode !== 'insight' && data.mode !== 'selections'">
    <button mat-button (click)="close(false)">Cancel</button>
    <button mat-flat-button color="primary" (click)="close(true)">
      {{ data.mode === 'delete' ? 'Delete' : 'Add' }}
    </button>
  </ng-container>
</mat-dialog-actions>
